import React, { useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import { SELECT_OPTION_ITEM_DATA, SelectElem } from '../../common/select';
import { PROPS_TYPE } from './constant';

export const Container: React.FC<PROPS_TYPE> = ({
  action,
  convert,
  initialOptions,
  formik,
  param,
  array = false,
  preloadOnFocus = false,
  debounce = 300,
  ...props
}) => {
  const setValue = (options: SELECT_OPTION_ITEM_DATA[], value: any) => {
    const optionList = options?.filter(
      (item: SELECT_OPTION_ITEM_DATA) => item.value === formik.values[value],
    )[0];
    return optionList ? optionList : null;
  };
  const setValueArray = (options: SELECT_OPTION_ITEM_DATA[], value: any) => {
    const optionList = options?.filter(
      (item: SELECT_OPTION_ITEM_DATA) => item.value === value,
    )[0];
    return optionList ? optionList : null;
  };

  const actioN = useMutation((e: any) => action(e, param), {});
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onInputChange = (e: string) => {
    if (e) {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => actioN.mutate(e, param), debounce);
    }
  };

  if (actioN.isLoading) {
    props.noOptionsMessage = 'Завантаження...';
  }
  if (actioN.isSuccess) {
    props.noOptionsMessage = undefined;
  }
  if (formik) {
    if (array) {
      props.value = setValueArray(
        actioN.data ? convert(actioN.data) : initialOptions,
        props.value,
      );
    } else {
      props.value = setValue(
        actioN.data ? convert(actioN.data) : initialOptions,
        props.name,
      );
    }
  }
  const e = { value: '', label: '' };
  useEffect(() => {
    if (param) {
      props.onChange(props.name, e);
      actioN.mutate('', param);
    }
  }, [param]);

  const onFocus = () => {
    if (preloadOnFocus && !actioN.isLoading && !actioN.data) {
      actioN.mutate('', param);
    }
  };

  return (
    <SelectElem
      {...props}
      options={actioN.data ? convert(actioN.data) : initialOptions}
      dynamic
      onInputChange={onInputChange}
      onFocus={onFocus}
    />
  );
};